import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "react-time-picker/dist/TimePicker.css";
import "../../assets/css/modal.css";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PopUp from "../Modals/Popup";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import "../../assets/css/form.css"
import "./PickUpDate.css";

const renderAddress = (props, order) => {
  if (props.method === 1) {
    if (props.address) { //Check if no address
      const address = props.address.full_address
      return address
    } else {
      return "Please select Address"
    }
  } else if (props.method === 2) {
    if (order.out_name) {
      return order.out_name
    } else if (localStorage.out_name) {
      return localStorage.out_name
    } else {
      return "Please select Outlet"
    }
  }
}

const PickupDate = (props) => {
  let order = props.order;

  let show = props.show;
  const [load, setLoad] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [lshow, setLshow] = useState(false);

  const dateObj = new Date()
  const [date, setDate] = useState(new Date());
  const [timeRange, setRange] = useState(`Select your ${props.method === 1 ? "Delivery" : "Pickup"} Time`);
  const [currentOrder, setOrder] = useState(props.method);
  const [timeRangeDP, setTimeRangeDP] = useState([]);

  const [timePopup, setTimePopup] = useState(false);


  useEffect(() => {
    var d = new Date(); // for now
    var h = d.getHours(); // => 9
    var m = d.getMinutes(); // =>  30

    var timeNow = parseFloat(h + '.' + m).toFixed(2);
    let outlet_id;
    var result = props.outlates?.business_location?.filter(obj => {
      outlet_id = props.order.out_id ? props.order.out_id : props.getCurrentOutlet.id;
      return obj.id === outlet_id;
    });

    if (result?.length > 0) {
      var collectTimeRange = [];
      var operationTimeRange = result[0].custom_field3;

      // set time range
      operationTimeRange.forEach(function (element, index) {
        for (let i = element[0]; i < element[1]; i += 0.25) {
          let startEndTime = [i, i + 0.25];

          if (parseFloat(timeNow) < i) {
            startEndTime.forEach(function (se, seIndex) {
              if (se > element[1]) {
                se = element[1];
              }

              let hours = Math.floor(se);
              let minutes = Math.round((se - hours) * 60);

              let ampm = hours >= 12 ? "PM" : "AM";
              if (hours > 12) hours -= 12;
              if (hours === 0) hours = 12;

              let minutesStr = minutes.toString().padStart(2, "0");
              startEndTime[seIndex] = `${hours}:${minutesStr} ${ampm}`;
            });

            collectTimeRange.push(startEndTime[0] + " - " + startEndTime[1]);
          }
        }
      });

      setTimeRangeDP(collectTimeRange);

      if (collectTimeRange?.length > 0) {
        setRange(collectTimeRange[0]);
      }
    }
  }, [props, order])

  useEffect(() => {
    // console.log(props);
    if (
      !props.loading &&
      props.norders &&
      props.norders !== null &&
      props.norders.success &&
      load
    ) {
      // console.log("_____orders____");
      //console.log(props.orders);
      // props.showTrackOrder();
      setLoad(false);
    }
  }, [props.outlates?.business_location, order, load]);

  const checkTime = (selectedTime) => {
    let pre_order_time = Number(props.business_location[0].pre_order_time) || 30;// default 30 mins
    let startTimeStr = selectedTime.split(" - ")[0];
    let now = new Date();
    let todayDateStr = now.toDateString();
    let slotStart = new Date(`${todayDateStr} ${startTimeStr}`);

    // subtract pre_order_time in minutes
    let cutoff = new Date(slotStart.getTime() - pre_order_time * 60 * 1000);

    let cutoffStr = cutoff.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit"
    });

    if (now >= cutoff) {
      setPopupText(`Not available for this slot. You needed to order before ${cutoffStr}`);
      setLshow(true);
      return false;
    }
    return true;
  };

  const changeDate = (date) => {
    setDate(date);

    let oldOrder = order;
    oldOrder["date"] = date.toDateString();
    props.setOrder(oldOrder);
    console.log(date)
    // const monthNames = ["January", "February", "March", "April", "May", "June",
    //   "July", "August", "September", "October", "November", "December"
    // ];

    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset * 60 * 1000));
    date = date.toISOString().split('T')[0];

    // console.log(date);

    // localStorage.setItem("date", date.getDate() + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear());
  }

  const changeTime = (time) => {
    // console.log(time, order);

    const isValid = checkTime(time)
    if (!isValid) {
      return;
    }

    let oldOrder = order;

    if (time != "Select your Pickup Time") {
      setRange(time);
      oldOrder["time"] = time;
    }

    props.setOrder(oldOrder);
    // localStorage.setItem("time", time);

    // console.log(time, oldOrder, order);
  }

  const ProceedOrder = () => {
    let oldData = order;
    const isValid = checkTime(timeRange);
    if (!isValid) {
      return;
    }
    if (oldData["date"] && oldData["time"]) {
      if (props.method === 2) {
        if (localStorage.date) {
          localStorage.removeItem("date")
        }
        localStorage.setItem("date", date.toLocaleDateString("en-US"))
      }

      console.log("Place order1");
      oldData["order_type"] = 2;

      //  oldData["cart_id"] = props.cartId();
      // props.placeOrder(oldData);
      // setLoad(true);
      props.setShowPayment(true)
      props.closeModal();
    }
    else if (date && timeRange) { //Set the button elements to the default value initially
      changeTime(timeRange)
      changeDate(date)
      props.closeModal();
    }
    else {
      setPopupText("Select Date and Time!");
      setLshow(true);
    }

    //props.showTrackOrder();
  };

  const returnTimeExp = (data, setName) => {
    return (data?.map((item, index) => (
      <Dropdown.Item
        onClick={() => {
          changeTime(item); setName(item)
        }}
        eventKey={index}
        style={{ textAlign: "center", width: "100%", color: "black" }}
      >
        {item}
      </Dropdown.Item>
    )))
  }

  if (currentOrder !== props.method) { //Check if user changed order type and set time, date to default
    setOrder(props.method)
    setRange(`Select your ${props.method === 1 ? "Delivery" : "Pickup"} Time`)
  }

  return (
    <Modal
      show={show}
      onHide={props.closeModal}
      dialogClassName="modal-md modal-dialog-scrollable"
      contentClassName="shrink modal_form"
      centered
      size="sm"
    >
      <PopUp
        text={popupText}
        show={lshow}
        closeModal={() => setLshow(false)}
      />
      <Modal.Header>
        <h4 className="modal-title">
          {" "}
          {props.method === 1 ? "Your delivery time" : "Pick up"}
        </h4>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.closeModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </Modal.Header>
      <Modal.Body className="no">



  <div
    style={{
      filter: timePopup ? "blur(4px)" : "none",
      pointerEvents: timePopup ? "none" : "auto",
      userSelect: timePopup ? "none" : "auto",
      transition: "filter 0.3s ease-in-out",
    }}
  >






        <div className="panel-ember">
          <label className="control-label">
            {" "}
            {props.method === 1 ? "Selected address " : "Selected outlet"}{" "}
          </label>
          <span
            className="btn secondry d-block"
            onClick={() => {
              // console.log(order.out_name)
            }} style={{ pointerEvents: "none" }}>
            {renderAddress(props, order)}
          </span>
        </div>
       <div className="pdbrd">
  <label className="control-label no">
    Select your {props.method === 1 ? 'delivery' : 'pick up'} <span>Date</span>
  </label>



  <DatePicker  minDate={new Date()} className="form-control" selected={date} onChange={changeDate} />


  {/* <div style={{ cursor: 'pointer' }}>
<DatePicker
  className="form-control"
  selected={date}
  onChange={changeDate}
  minDate={new Date()}
  popperPlacement="bottom-end"
  disabled={true}
/>
</div> */}




        </div>
        <div className="pdbrd no">
  <label className="control-label no" style={{ display: "block" }}>
    Select your {props.method === 1 ? 'delivery' : 'pick up'} <span>Time</span>
  </label>

  <button
    className="btn secondry d-block"
    style={{ width: "100%", backgroundColor: "#f1f1f1", color: "black" }}
    onClick={() => setTimePopup(true)}
  >
    {timeRange || "Select Time"}
  </button>

<Modal
  show={timePopup}
  onHide={() => setTimePopup(false)}
  centered
  dialogClassName="time-popup-dialog"
  style={{ padding: 0 }}
>
  <Modal.Header closeButton>
    <Modal.Title>Select Time</Modal.Title>
  </Modal.Header>

  <Modal.Body
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "1rem",
      maxHeight: "40vh",
      overflowY: "auto",
      width: "100%",
      borderBottom: "4px solid red",
      borderRadius: "0 0 8px 8px",
    }}
  >
    {timeRangeDP.map((time, idx) => (
      <button
        key={idx}
        className="btn btn-outline-primary"
        style={{
          width: "80%",
          color: "black",
          borderColor: "black",
          backgroundColor: "white",
        }}
        onClick={() => {
          changeTime(time);   // update order
          setRange(time);     // update button display
          setTimePopup(false);
        }}
        onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f1f1f1"}
        onMouseLeave={e => e.currentTarget.style.backgroundColor = "white"}
      >
        {time}
      </button>
    ))}
  </Modal.Body>
</Modal>
</div>
</div>
      </Modal.Body>
      <Modal.Footer className="form-action no">
        <button className="btn lg primary d-block" onClick={ProceedOrder}>
          Proceed
        </button>
      </Modal.Footer>
    </Modal>
  );
};

PickupDate.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  outlates: state?.products?.outlates,
  norders: state?.products?.order,
  loading: state?.products?.loading,
  business_location: state?.products?.business_location,
  getCurrentOutlet: state?.products?.getCurrentOutlet
});
export default withTranslation()(connect(mapStateToProps, {})(PickupDate));









